import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class WorkloadAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

// ******************************
//        Public methods
// ******************************

// UPDATE //
  updateSuccess() {
    const message = {
      body: 'WORKLOAD_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'WORKLOAD_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
}

angular
  .module('bringoz.admin.workload')
  .service('workloadAlerts', WorkloadAlerts);

